import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import EnrolmentWelcome from './EnrolmentWelcome';
import EnrolmentForm from './EnrolmentForm';
import EnrolmentConfirmation from './EnrolmentConfirmation';
import FindLearnerViewModel from '../ViewModels/FindLearnerViewModel';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

interface IEnrolmentProps {
}

interface IEnrolmentState {
    model: FindLearnerViewModel | undefined;
    enrolmentComplete: boolean;
}

export class Enrolment extends Component<IEnrolmentProps & WithStyles<typeof styles>, IEnrolmentState> {
    constructor(props) {
        super(props);

        this.state = {
            model: undefined,
            enrolmentComplete: false,
        };
    }

    public componentDidMount() {
    }

    public render() {

        return (
            <React.Fragment>
                {this.state.model === undefined ?
                    <EnrolmentWelcome setModel={this.setModel} />
                    :
                    this.state.enrolmentComplete === false ? 
                        <EnrolmentForm model={this.state.model} setComplete={this.setComplete}/>
                        :
                        <EnrolmentConfirmation />
                }
            </React.Fragment>
        );
    }

    private setModel = (newModel) => {
        this.setState({ model: newModel });
    }

    private setComplete = (value) => {
        this.setState({ enrolmentComplete: value });
    }
}

export default withStyles(styles)(Enrolment);

